<template>
  <v-card>
    <v-toolbar color="primary" dark dense>
      <v-toolbar-title>Список занимаемых постов</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="dialogClose">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="pa-0">
      <v-list>
        <template v-if="companies.length==0">
          <v-list-tile dense>
            <v-list-tile-content>
              <v-list-tile-title>Пользователь не состоит ни в одной группе</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        <template v-else>
          <v-list-group v-for="item in companies" v-model="item.active" :key="item.name" prepend-icon="mdi-domain" no-action>
            <v-list-tile slot="activator" dense>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-for="subItem in item.posts" :key="subItem.name" @click dense>
              <v-list-tile-content>
                <v-list-tile-title>{{ subItem.name }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-icon>mdi-account</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { accountList } from '@/apps/orgstructure/api'
import dialogMixin from '@/mixins/dialog'
export default {
  name: 'PostsForm',
  mixins: [dialogMixin],
  props: {
    account: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      companies: []
    }
  },

  created() {
    accountList(this.account.id).then(
      data => {
        this.companies = data.companies
        this.dialogSetLoading(false)
      },
      error => {
        this.$dmsErrorNoty('Не удалось получить данные по компаниям')
        this.dialogClose()
      }
    )
  },

  methods: {
    submit() {
      this.dialogClose()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/apps/accounts/components/Forms/PostsForm.vue